import { createReducer } from 'redux-create-reducer';

import {
  CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES,
} from '../types';

const initialState = {
  isLoading: false,
};

const createHighRiskCountryReducer = createReducer(initialState, {
  [CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES.DEFAULT]: state => ({
    ...state,
    isLoading: true,
  }),
  [CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES.PENDING]: state => ({
    ...state,
    isLoading: true,
  }),
  [CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES.REJECTED]: state => ({
    ...state,
    isLoading: false,
  }),
  [CREATE_WATCH_LIST_ENTRY_HIGH_RISK_COUNTRIES.FULFILLED]: state => ({
    ...state,
    isLoading: false,
  }),
});


export default createHighRiskCountryReducer;


// WEBPACK FOOTER //
// ./src/features/watch-list-entry-high-risk-country/reducers/createHighRiskCountryReducer.js